import React, { useEffect } from 'react'
import { useRouteMatch } from 'react-router-dom'

import DashboardRouter from 'Config/Routing/DashboardRouter'

import Header from 'Containers/Header'
import Sidebar from 'Containers/Sidebar'
import { UIBlock } from 'Containers/UIBlock'
import 'rc-calendar/assets/index.css'
import ReduxModal from '../../Components/ReduxModal/container/ReduxModal'

import store from '../../Config/store'
import { use as useWs, release as releaseWs } from '../../shared/websockets'
import { getConversationsAsync } from '../../Module/WS/websockets'
import { authorization } from '../../Module/Auth/Auth'
import { ROLE_ADMIN, ROLE_CITY_MANAGER } from '../../shared/constants'

const App = () => {
  const match = useRouteMatch()

  useEffect(() => {
    const { role } = authorization.getUser()
    if (![ROLE_ADMIN, ROLE_CITY_MANAGER].includes(role)) return

    const { websockets } = store.getState()
    // Connect to WS on mount
    if (!websockets.connected) {
      useWs({
        onConnect: () =>
          getConversationsAsync({
            ack: 'initialLoad',
            first: 20,
            archived: false,
          }),
      })
    }
    // Release on dismount
    return () => {
      if (websockets.connected) {
        releaseWs()
      }
    }
  }, [])

  return (
    <div style={{ width: '100%' }}>
      <UIBlock>
        <Header />
        <Sidebar match={match.url}>
          <DashboardRouter match={match.url} />
        </Sidebar>
        <ReduxModal />
      </UIBlock>
    </div>
  )
}

export default App



// WEBPACK FOOTER //
// ./src/Containers/App/index.js